import type { PropsWithChildren } from "react";

import { Popover, PopoverTrigger } from "@similarweb/ui-components";

import type { QuotaOperationState } from "app/pages/sales-intelligence/modules/quota/types";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { StyledPopoverContent } from "./styles";

type Props = PropsWithChildren<{
    quota: QuotaOperationState;
}>;

const ExportQuotaHoverContainer = ({ children, quota }: Props) => {
    const translate = useTranslation();

    const key = quota.total === 0 ? "si.websites-export.disabled.text" : "si.websites-export.quota-reached.text";

    return (
        <Popover
            placement="top"
            withArrow
            isHover
        >
            <PopoverTrigger asChild>
                <div>{children}</div>
            </PopoverTrigger>

            <StyledPopoverContent>{translate(key)}</StyledPopoverContent>
        </Popover>
    );
};

export default ExportQuotaHoverContainer;
